import { useCallback, useEffect, useState } from "react";
import { loadWhiteboardElements } from "../services/whiteboardService";
import { describeBoard } from "../components/whiteboard/describeBoard";
import { tagToolbarFrameworks } from "../components/whiteboard/frameworks";

export default function useWhiteboardContents(userId, roomId) {
  const [byRoom, setByRoom] = useState({});

  const remember = useCallback((room, text, { keep = false } = {}) => {
    if (!room || !text) return;
    setByRoom((prev) => ((keep && prev[room]) || prev[room] === text ? prev : { ...prev, [room]: text }));
  }, []);

  const report = useCallback((text) => remember(roomId, text), [remember, roomId]);

  useEffect(() => {
    if (!userId || !roomId) return undefined;
    let cancelled = false;
    loadWhiteboardElements(userId, roomId).then((els) => {
      if (cancelled || !els) return;
      remember(roomId, describeBoard(tagToolbarFrameworks(els)), { keep: true });
    });
    return () => { cancelled = true; };
  }, [userId, roomId, remember]);

  return [byRoom[roomId] || null, report];
}
